'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responderKeyInvariant = undefined;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _numberIdInvariant = require('conversations-async-data/indexed-async-data/invariants/numberIdInvariant');

var _responderKeyGetters = require('./responderKeyGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var responderKeyInvariant = exports.responderKeyInvariant = function responderKeyInvariant(responderKey) {
  var id = (0, _responderKeyGetters.getId)(responderKey);
  var type = (0, _responderKeyGetters.getType)(responderKey);
  (0, _invariant2.default)(!!id, 'Responder ID must be set in the key map');
  (0, _numberIdInvariant.numberIdInvariant)(id);
  (0, _invariant2.default)(!!type, 'Responder type must be set in the key map');
};